import DistrictReportsVue from '@/views/sic/district-reports/district-reports.vue';

const basePath = '/sic/district-reports';
const role = 'sic'; // 角色身份

export const SIC_DISTRICT_REPORTS_INDEX = 'sic-district-reports-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: DistrictReportsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_DISTRICT_REPORTS_INDEX,
      component: () => import(
        /* webpackChunkName: "reports" */
        `@/views/${role}/district-reports/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
